/**
 * ZIP code → city, state and centre point, from the backend's public
 * `POST /location/geocode-zip` (zippopotam.us behind a server cache).
 */
import { apiClient } from '@/shared/api';
import type { ZipFallbackDetails } from '@/types/location';

/** A complete US ZIP: five digits, optionally ZIP+4. */
export const US_ZIP_PATTERN = /^\d{5}(-\d{4})?$/;

export async function lookupZip(zip: string): Promise<ZipFallbackDetails | null> {
    const response = await apiClient.post<{ success: boolean; data: ZipFallbackDetails }>(
        '/location/geocode-zip',
        { zip: zip.slice(0, 5) },
    );
    return response.data?.data ?? null;
}
